<div class="popup" #popupRoot>
    <ng-content></ng-content>
</div>
